module.exports = __webpack_public_path__ + "img/zk-icon-coupon.2825d9a9.svg";